<template>
  <v-app>
    <v-container
      class="d-flex flex-column align-center justify-center text-center fill-height"
      fluid
    >
      <slot />
    </v-container>
  </v-app>
</template>
